import React from 'react'
import {ReactComponent as ArrowIcon} from "./../../../assets/svgs/top-right-arrow-icon.svg";
import {routesContainer} from "../../../store/global/action_creators_consts";
require("./reportErrorsStatus.scss");

const ReportErrorsStatus = ({errorCount, lastReportId}) => {
    return (
        <div className="report-error-status">
            {errorCount > 0 && <div className="red-circle"/>}
            <div className="report-error-status-text">{errorCount > 0 ? errorCount : "None"}</div>
            {errorCount > 0 && <div className="report-error-link" onClick={() => routesContainer.routes.push(`/report-errors/${lastReportId}`)}><ArrowIcon className="goto-error"/></div>}
        </div>
    )
}

export default ReportErrorsStatus;
